<div class="custom-confirm-container">
  <div class="bg-light-2-primary pt-2 pb-2 pe-3 ps-3 d-flex justify-content-between align-items-center">
    <div class="title fw-bold fs-18">{{ conFirmMsg }}</div>

    <mat-icon (click)="onNo()">close</mat-icon>
  </div>
  <div class="actions w-100 d-flex justify-content-between mt-2 p-3">
    <button class="btn-md-filled-error fw-bold justify-center" matRipple>No</button>
    <button class="btn-md-filled-primary fw-bold justify-center" matRipple (click)="onYes()">Yes</button>
  </div>
</div>
